<div class="databases-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2 id="storage-title">{{ 'Storage' | translate }}</h2>
      <p>{{ 'Postgres connection slots on this API instance' | translate }}</p>
    </div>
    <div class="header-actions">
      <app-secondary-button class="header-actions__refresh" title="Refresh" icon="refresh" (action)="refresh()"></app-secondary-button>
    </div>
  </div>

  <div class="storage-boards">
    <app-orchestration-database-slot-board
      heading="Postgres"
      [loading]="loading()"
      [snapshot]="snapshot()"
      [errorMessage]="errorMessage()"
    ></app-orchestration-database-slot-board>
    <app-orchestration-object-storage-board
      heading="Object storage"
      [loading]="storageLoading()"
      [snapshot]="storageSnapshot()"
      [errorMessage]="storageErrorMessage()"
    ></app-orchestration-object-storage-board>
  </div>
  <div class="storage-occupancy">
    <app-orchestration-storage-occupancy
      heading="Database occupancy"
      [rows]="databaseOccupancy()"
    ></app-orchestration-storage-occupancy>
    <app-orchestration-storage-occupancy
      heading="Object-storage occupancy"
      [rows]="bucketOccupancy()"
      [objectCount]="bucketObjectCount()"
    ></app-orchestration-storage-occupancy>
  </div>
  <section class="database-sizes orch-table-panel">
    <app-orchestration-table-heading heading="Database sizes" queryParam="databases" [(query)]="databaseSearch">
      <p>{{ 'Total size' | translate }}: {{ totalSizeLabel() }}</p>
    </app-orchestration-table-heading>
    <app-data-table
      [columns]="sizeTableColumns"
      [data]="visibleDatabases()"
      [config]="sizeTableConfig"
      [totalRecords]="visibleDatabases().length"
    ></app-data-table>
  </section>
  <section class="object-storage">
    <div class="object-storage__windows" role="group" [attr.aria-label]="'Object-storage write window' | translate">
      @for (window of writeWindowChips; track window.id) {
        <button
          type="button"
          class="object-storage__window"
          [class.object-storage__window--active]="storageWindow() === window.id"
          (click)="selectWriteWindow(window.id)"
        >
          {{ window.label | translate }}
        </button>
      }
    </div>
    @if (writesErrorMessage()) {
      <div class="error-message">{{ writesErrorMessage() | translate }}</div>
    }
    <msf-p-chart
      chartType="bar"
      [chartData]="writeChartData()"
      [config]="writeChartConfig"
      [noDataMessage]="'No object-storage writes in this window' | translate"
    ></msf-p-chart>
    <div class="orch-table-panel object-storage__buckets">
      <app-orchestration-table-heading heading="Object-storage buckets" queryParam="buckets" [(query)]="bucketSearch">
      </app-orchestration-table-heading>
      <app-data-table
        [columns]="bucketTableColumns()"
        [data]="visibleBuckets()"
        [config]="bucketTableConfig"
        [totalRecords]="visibleBuckets().length"
        (onRowClick)="toggleBucket($event)"
      ></app-data-table>
    </div>
    @if (selectedBucket(); as bucket) {
      <app-orchestration-bucket-files
        [bucket]="bucket"
        [refreshTick]="filesRefreshTick()"
        (closed)="closeBucket()"
      ></app-orchestration-bucket-files>
    }
  </section>
  <section class="connection-groups orch-table-panel">
    <app-orchestration-table-heading heading="Connection groups" queryParam="groups" [(query)]="groupSearch">
    </app-orchestration-table-heading>
    <app-data-table
      [columns]="tableColumns"
      [data]="visibleGroups()"
      [config]="tableConfig"
      [totalRecords]="visibleGroups().length"
    ></app-data-table>
  </section>
</div>

<ng-template #bucketNameTemplate let-row>
  <button
    type="button"
    class="bucket-open"
    [class.bucket-open--active]="row.name === selectedBucket()"
    [attr.aria-pressed]="row.name === selectedBucket()"
    (click)="toggleBucket(row); $event.stopPropagation()"
  >{{ row.name }}</button>
</ng-template>

<ng-template #writersTemplate let-row>
  @if (row.writers.length) {
    <div class="object-storage__writers">
      @for (writer of row.writers; track writer.processKey + writer.command) {
        <app-copyable-identifier
          [value]="writer.processKey || ''"
          [display]="(writer.displayName || writer.processKey) | translate"
        ></app-copyable-identifier>
      }
    </div>
  } @else {
    <span>—</span>
  }
</ng-template>
